'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var wrc = window.winresCloud;

var WinresOmalomaDocuments = function () {
  function WinresOmalomaDocuments($rootScope, $scope, omalomaService, $sce, $timeout) {
    _classCallCheck(this, WinresOmalomaDocuments);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.$sce = $sce;
    this.$timeout = $timeout;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // waiting_for_parameter - Waiting for a dynamic parameter to be set.
    // loading - Loading info.
    // ready - Info loaded.
    // error - Failed to load info.
    this.setStatus('init', null);

    // An error to be displayed. Passed to i18next.
    // Example error: Failed to fetch data from backend.
    this.$scope.error = null;

    this.$scope.documents = [];

    // Files upload array
    this.$scope.files = [];
    this.$scope.selectedType = null;

    this.types = [];
  }

  _createClass(WinresOmalomaDocuments, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        return _this.setStatus('out', null);
      });
      this.$scope.$watch(function () {
        return _this.bookingNumber;
      }, function () {
        return _this.load();
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      } else {
        this.setStatus('out', null);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      // Booking number is taken from bookings.
      // If no bookings, will wait indefinitely. no-bookings broadcast is called by winresOmaloaBookingPicker.js
      // which tells if there are no bookings.
      this.$scope.$on('no-bookings', function () {
        return _this2.setStatus("no_bookings", null);
      });
      if (!this.bookingNumber) {
        if (this.omalomaService.isLoggedInAsCustomer()) {
          console.log('[WOBS] Booking number not available yet.');
          this.setStatus('waiting_for_parameter', null);
        }
        return;
      }

      this.setStatus('loading', null);

      this.omalomaService.isCustomerUploadInUse().then(function (inUse) {
        if (inUse) {
          _this2.loadCustomerBookingFileTypes();
          _this2.loadCustomerBookingFiles();
        } else {
          _this2.setStatus('not-in-use', null);
        }
      });
    }
  }, {
    key: 'loadCustomerBookingFileTypes',
    value: function loadCustomerBookingFileTypes() {
      var _this3 = this;

      this.omalomaService.getCustomerBookingFileTypes(this.bookingNumber).then(function (types) {
        _this3.types = types;
      });
    }
  }, {
    key: 'loadCustomerBookingFiles',
    value: function loadCustomerBookingFiles() {
      var _this4 = this;

      this.$scope.linkSessionID = this.omalomaService.getSessionId();

      this.$scope.documentsLoading = true;
      this.omalomaService.getCustomerBookingFiles(this.bookingNumber).then(function (documents) {
        _this4.$scope.documents = externalCustomerBookingDocuments(_this4.$sce, _this4.bookingNumber, documents);
        _this4.$scope.documentsLoading = false;
        _this4.setStatus('ready', null);
        _this4.checkBookingInProcess();
      }).catch(function (error) {
        console.error('[WOD] Failed to load customer booking files:', error);
        _this4.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'selectType',
    value: function selectType(type) {
      this.$scope.selectedType = type;
    }
  }, {
    key: 'selectPrivateCustomerBookingFile',
    value: function selectPrivateCustomerBookingFile(file) {
      var _this5 = this;

      if (file.remove) {
        // Remove file from upload array
        this.$scope.files = _.filter(this.$scope.files, function (f) {
          return !f.remove;
        });

        // Disable upload button
        this.$scope.hasNewFiles = false;
        return;
      }

      file.status = 'loading';

      this.omalomaService.loadPrivateCustomerBookingFile(file).then(function (result) {
        if (result && result.valid) {
          // Get base64 after 'data:text/plain;base64,'
          file.base64 = result.base64.split(',')[1];

          file.selectedType = _this5.$scope.selectedType;

          _this5.$scope.files.push(file);

          // Enable upload button
          _this5.$scope.hasNewFiles = true;

          file.status = 'waiting';
        } else {
          var error = "";

          if (result.error === 1) error = 'max_size';else if (result.error === 2) error = 'invalid_type';

          file.status = 'load_error';
          console.error('Failed to load', file.name, error === 'max_size' ? 'max size 5 MB' : error === 'invalid_type' ? 'invalid type' : '');

          var popup = { type: 'error',
            message: error === 'max_size' ? 'Tiedoston maksimikoko on 5 MT' : error === 'invalid_type' ? 'Sallitut tiedostomuodot: jpg ja pdf' : '' };

          _this5.popupMessage(popup);
        }
      }, function (error) {
        file.status = 'load_error';
        console.error('Failed to load', file.name, error);
      });
    }
  }, {
    key: 'uploadPrivateCustomerBookingFiles',
    value: function uploadPrivateCustomerBookingFiles() {
      var _this6 = this;

      _.each(this.$scope.files, function (file) {
        if (file.status === 'waiting') {
          file.status = 'uploading';
          _this6.omalomaService.uploadPrivateCustomerBookingFile(_this6.bookingNumber, file, false).then(function (uploadedFile) {
            if (uploadedFile) {
              file.status = 'uploaded';
              _this6.showDocumentModal = false;
              _this6.load();
            } else {
              file.status = 'upload_error';
              console.error('Failed to upload', file.name);
            }

            var popup = { type: file.status === 'uploaded' ? 'success' : file.status === 'upload_error' ? 'error' : '',
              message: file.status === 'uploaded' ? uploadedFile.Name + ' tallennus onnistui' : file.status === 'upload_error' ? file.name + ' tallennus epäonnistui' : '' };

            _this6.popupMessage(popup);
          });
        }
      });

      // Disable upload button
      this.$scope.hasNewFiles = false;
    }
  }, {
    key: 'popupMessage',
    value: function popupMessage(popup) {
      var _this7 = this;

      this.popup = popup;

      this.$timeout(function () {
        return _this7.popup = null;
      }, 8000);
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WOBS] Set status to', status);
      if (error !== undefined) {
        if (error) console.log('[WOBS] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'checkBookingInProcess',
    value: function checkBookingInProcess() {
      var _this8 = this;

      this.omalomaService.getCustomerBookingBalance(this.bookingNumber).then(function (balance) {
        // Booking invoices total price does not match with booking total price.
        // Prevent document uploading. 
        _this8.$scope.bookingInProcess = balance.Error === 'InvalidTotal';

        if (_this8.$scope.bookingInProcess === true) {
          _this8.setStatus('booking_in_process', null);
        }
      });
    }
  }]);

  return WinresOmalomaDocuments;
}();

WinresOmalomaDocuments.$inject = ['$rootScope', '$scope', 'omalomaService', '$sce', '$timeout'];

_module3.default.component('winresOmalomaDocuments', {
  template: require('./winresOmalomaDocuments.html'),
  controller: WinresOmalomaDocuments,
  require: {},
  bindings: {
    bookingNumber: '<'
  }
});

function externalCustomerBookingDocuments($sce, bid, dd) {
  return _.map(dd, function (url, i) {
    return {
      type: url.Type,
      number: i + 1,
      url: $sce.trustAsResourceUrl(wrc.endpoint + "Filebank/Download/Bookings/" + bid + "/" + url.Type + "s/" + url.Name), // <endpoint>/Filebank/Download/Bookings/this.bookingNumber/<url.Type>s/url.Name
      text: url.Name,
      icon: 'file'
    };
  });
}

// File browser button with loading indicator
_module3.default.directive('fileBrowseButton', function () {
  return {
    restrict: 'E',
    scope: {
      text: '@',
      name: '@',
      accept: '@',
      showFile: '@',
      fileChange: '&',
      types: '=',
      typeChange: '&'
    },

    link: function link(scope, element, attrs) {
      scope.text = attrs.text;
      scope.name = attrs.name;
      scope.accept = attrs.accept;
      scope.showFile = attrs.showFile;
      scope.type = null;
      // scope.type = scope.types[0]; // select first by default

      // Call file-change
      scope.fChange = function (file) {
        scope.file = file;
        scope.fileChange({ $file: file });
      };

      scope.removeFile = function () {
        scope.file.remove = true;
        scope.fileChange({ $file: scope.file });
        scope.file = null;
      };

      // Call type-change
      scope.tChange = function (type) {
        if (scope.file) scope.removeFile();
        scope.type = type;
        scope.typeChange({ $type: type });
      };

      scope.fileInput = element[0].querySelector('input');
      scope.openFileBrowser = function () {
        scope.fileInput.click();
      };
    },

    // TODO: Use html file
    template: '\n      <div class="row file-row align-items-center" \n           ng-class="{\'bg-danger\': (showFile && (file.status == \'load_error\' || file.status == \'upload_error\')), \'bg-success\': (showFile && file.status == \'uploaded\')}">\n        <select class="col-xs-12 col-sm-4"\n                ng-show="types && types.length > 0"\n                ng-options="type for type in types"\n                ng-model="type"\n                ng-change="tChange(type)">\n        </select>\n        <div class="col-xs-12 col-sm-4">\n          <button class="file-button" \n                  ng-disabled="!type"\n                  ng-click="openFileBrowser()"\n                  ng-bind="text"></button>\n          <input type="file" \n                 name="{{ name }}" \n                 accept="{{ accept }}" \n                 file-on-change="fChange($file)" \n                 style="display: none;"/>\n        </div>\n        <div class="col-xs-12 col-sm-4 file-loading-bar" \n             ng-show="showFile && (file.status == \'loading\' || file.status == \'uploading\')"></div>\n        <div class="col-xs-6 col-sm-2" \n             ng-show="showFile && (file.status != \'loading\' && file.status != \'uploading\')">\n          <strong ng-bind="file.name"></strong>\n        </div>\n        <div class="col-xs-6 col-sm-2 file-remove"\n             ng-show="showFile && file && (file.status != \'loading\' && file.status != \'uploading\')">\n             <span style="float: right;"\n                   ng-click="removeFile()">&times;</span>\n        </div>\n      </div>\n      '
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaDocuments/winresOmalomaDocuments.js
// module id = 363
// module chunks = 2